<div class="titlebox-container">
    <div class="titlebox-text-container">
        <div> {{title|translate}}</div>
        <mat-icon (click)="clickIconEmitter()" class="deneme" [id]="'img-'+element"  width="30" height="30" svgIcon="arrow-down"></mat-icon>
        <!-- <img class="deneme" [id]="'img-'+element"  width="30" height="30" src="assets/images/icons/up.png" (click)="clickIconEmitter()"/> -->
        
    </div>
    <mat-progress-bar mode="determinate" [value]="controlValue"></mat-progress-bar>
</div>